"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _RoomCard = require("./RoomCard.propTypes");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _constants = require("./constants");
var BenefitIcon = _styledComponents.default.div.withConfig({
  displayName: "Benefit__BenefitIcon",
  componentId: "sc-hbp203-0"
})(["padding-right:", ";min-width:", ";text-align:center;padding-top:", ";"], function (_ref) {
  var theme = _ref.theme,
    isMobile = _ref.isMobile;
  return !isMobile ? "".concat(theme.space.XXXSmall) : "".concat(theme.space.tiny);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.space.standard);
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.space.mini);
});
var BenefitContent = _styledComponents.default.div.withConfig({
  displayName: "Benefit__BenefitContent",
  componentId: "sc-hbp203-1"
})(["display:flex;flex-direction:column;"]);
var BeneFitPrimaryText = _styledComponents.default.div.withConfig({
  displayName: "Benefit__BeneFitPrimaryText",
  componentId: "sc-hbp203-2"
})(["font-size:", ";line-height:", ";color:", ";"], function (_ref4) {
  var theme = _ref4.theme,
    isMobile = _ref4.isMobile;
  return !isMobile ? theme.fontSize.small : theme.fontSize.XSmall;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref6) {
  var theme = _ref6.theme,
    color = _ref6.color;
  return theme.colors[color] || theme.colors.secondary;
});
var BeneFitSecondaryText = _styledComponents.default.div.withConfig({
  displayName: "Benefit__BeneFitSecondaryText",
  componentId: "sc-hbp203-3"
})(["font-size:", ";line-height:", ";color:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.XSmall;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.lineHeight.small;
}, function (_ref9) {
  var theme = _ref9.theme,
    color = _ref9.color;
  return theme.colors[color] || theme.colors.secondary;
});
var Benefit = function Benefit(_ref10) {
  var icon = _ref10.icon,
    primaryText = _ref10.primaryText,
    secondaryText = _ref10.secondaryText,
    color = _ref10.color,
    cancellationPenaltyType = _ref10.cancellationPenaltyType,
    isMobile = _ref10.isMobile;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(BenefitIcon, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: icon,
    color: color,
    fontsize: cancellationPenaltyType === _constants.CANCELLATION_PENALTY_TYPES.FULL || !secondaryText ? 'small' : undefined
  })), /*#__PURE__*/_react.default.createElement(BenefitContent, null, primaryText && /*#__PURE__*/_react.default.createElement(BeneFitPrimaryText, {
    color: color,
    isMobile: isMobile
  }, primaryText), secondaryText && /*#__PURE__*/_react.default.createElement(BeneFitSecondaryText, {
    color: primaryText ? 'greyDark' : 'greyDarker'
  }, secondaryText)));
};
Benefit.propTypes = _RoomCard.OptionsAndBenefitsInfoPropTypes;
Benefit.defaultProps = _RoomCard.OptionsAndBenefitsInfoDefaultValues;
var _default = Benefit;
exports.default = _default;